import { create } from 'zustand';

type Store = {
  isEmptySearch: boolean;
  registerUpdate: (id: string) => void;
  scheduled: Record<string, true>;
  scheduleUpdate: (id: string) => void;
  scheduleUpdateBatch: (ids: { id: string; isHasBeenChanged: boolean }[]) => void;
  setEmptySearch: (state: boolean) => void;
};

export const useScenarioCapTableStore = create<Store>((set, get) => ({
  scheduled: {},
  isEmptySearch: false,

  setEmptySearch: (state) => {
    set(() => ({
      isEmptySearch: state,
    }));
  },
  scheduleUpdate: (id) => {
    set((state) => ({
      scheduled: { ...state.scheduled, [id]: true },
    }));
  },

  scheduleUpdateBatch: (ids) => {
    const updated: Record<string, true> = { ...get().scheduled };
    for (const { id, isHasBeenChanged } of ids) {
      if (isHasBeenChanged) {
        updated[id] = true;
      } else {
        delete updated[id];
      }
    }
    set({ scheduled: updated });
  },

  registerUpdate: (id) => {
    const updated = { ...get().scheduled };
    delete updated[id];
    set({ scheduled: updated });
  },
}));
